import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1c519b1e")

_pushScopeId("data-v-1c519b1e")
const _hoisted_1 = { class: "card-body-tags" }
const _hoisted_2 = { class: "tag-items" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus fs-16" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tags, (tag, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "tag-item",
          key: index
        }, [
          _createVNode("div", {
            class: {'priductTypesColor': tag.id == -1},
            onClick: ($event: any) => (_ctx.editTag(tag.id))
          }, _toDisplayString(tag.id == -1 ? _ctx.$t("productTypeTitle") : tag.name), 11, ["onClick"])
        ]))
      }), 128))
    ]),
    _createVNode("div", {
      class: "add-tag-btn",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.CreateNewTag()))
    }, [
      _hoisted_3
    ])
  ]))
})